import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-900">
      <div className="w-full px-6 md:px-10 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-start justify-between gap-12 mb-14">
          <div className="max-w-xs">
            <Link to="/" className="flex items-center gap-3 mb-4">
              <div className="w-9 h-9 rounded-full bg-primary-500 flex items-center justify-center">
                <i className="ri-shopping-bag-3-line text-base text-background-50"></i>
              </div>
              <span className="text-lg font-heading font-semibold text-background-50 tracking-tight">
                Itaobuy
              </span>
            </Link>
            <p className="text-sm text-foreground-300 leading-relaxed">
              La risorsa piu completa in Italia per scoprire e utilizzare Itaobuy Spreadsheet. Guide, prodotti, sicurezza e molto altro.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Categorie</h4>
            <div className="grid grid-cols-2 gap-x-8 gap-y-2">
              {categories.slice(0, 8).map((cat) => (
                <a
                  key={cat.seq}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Altre Categorie</h4>
            <div className="grid grid-cols-1 gap-y-2">
              {categories.slice(8).map((cat) => (
                <a
                  key={cat.seq}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Link Rapidi</h4>
            <div className="flex flex-col gap-y-2">
              <Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">Home</Link>
              <Link to="/guida-itaobuy-spreadsheet" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">Guida Completa</Link>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap"
              >
                Itaobuy Sheet
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap"
              >
                Buy It Now
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-foreground-700/30 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-foreground-400">
            &copy; {new Date().getFullYear()} Itaobuy Spreadsheet Italia. Tutti i diritti riservati.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors">
              <i className="ri-twitter-x-line"></i>
            </a>
            <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors">
              <i className="ri-instagram-line"></i>
            </a>
            <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors">
              <i className="ri-pinterest-line"></i>
            </a>
            <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors">
              <i className="ri-youtube-line"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}